<template>
  <div 
  id="g-recaptcha"
  :data-sitekey="sitekey">
  </div>
</template>

<script>
export default {
  name: 'Recaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    }
  },
  data: ()  => {
    return {
      widgetId: 0
    }
  },
  methods: {
    execute () {
      window.grecaptcha.execute(this.widgetId)
    },
    reset () {
      window.grecaptcha.reset(this.widgetId)
    },
    render () {
      if (window.grecaptcha && window.grecaptcha.render) {
        this.widgetId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          size: 'invisible',
          // the callback executed when the user solve the recaptcha
          callback: (response) => {
            // emit an event called verify with the response as payload
            this.$emit('verify', response)
            // reset the recaptcha widget so you can execute it again
            this.reset() 
          }
        })
      } else {
        console.warn('Forced refresh to load reCaptcha');
        window.location.reload();
      }
    }
  },
  mounted () {
    // render the recaptcha widget when the component is mounted
    this.render()
  }
}
</script>

<style scoped>

</style>